import { Box, VStack } from "@chakra-ui/react";

import { useAuthenticationMode } from "modules/authentication/infrastructure/useAuthenticationMode";
import { AuthenticationMode } from "modules/authentication/application/types/AuthenticationMode";
import { SsoLoginButton } from "modules/authentication/presentation/LoginForm/SsoLoginButton";

import { ChakraText } from "components/ChakraText";

import { Login } from "../../Authentication/Login";
import { Register } from "../../Authentication/Register";
import { MobileAuthenticationDropdown } from "./MobileAuthenticationDropdown";

const MobileAuthentication = () => {
  const authenticationMode = useAuthenticationMode();

  switch (authenticationMode) {
    case AuthenticationMode.Guest:
      return <></>;
    case AuthenticationMode.Sso:
    case AuthenticationMode.GuestAndSso:
      return (
        <MobileAuthenticationDropdown>
          <SsoLoginButton />
        </MobileAuthenticationDropdown>
      );
    case AuthenticationMode.Local:
    case AuthenticationMode.LocalAndSso:
    case AuthenticationMode.LocalAndGuest:
    case AuthenticationMode.LocalAndGuestAndSso:
      return (
        <MobileAuthenticationDropdown>
          <LoginRegister />
        </MobileAuthenticationDropdown>
      );
    default:
      return <></>;
  }
};

const LoginRegister = () => {
  return (
    <VStack spacing={4} p={4} w="100%">
      <Login
        loginBtnProps={{
          w: "100%",
        }}
      />
      <Box w="100%" textAlign="center">
        <ChakraText>Nie posiadasz konta?</ChakraText>
        <Register registerBtnProps={{ w: "100%" }} />
      </Box>
    </VStack>
  );
};

export { MobileAuthentication };
